import { LazoUser } from "@/models/LazoUser";
import React, { createContext, useContext, useMemo, useState } from "react";

type LazoUserContextType = {
  lazoUser: LazoUser | null;

  setLazoUser: (user: LazoUser | null) => void;
};

const LazoUserContext = createContext<LazoUserContextType | undefined>(undefined);

type LazoUserProviderProps = {
  children: React.ReactNode;
};

export const LazoUserProvider: React.FC<LazoUserProviderProps> = ({ children }) => {
  const [lazoUser, setLazoUser] = useState<LazoUser | null>(null);

  const contextValue = useMemo(
    () => ({
      lazoUser,
      setLazoUser,
    }),
    [lazoUser]
  );

  return <LazoUserContext.Provider value={contextValue}>{children}</LazoUserContext.Provider>;
};

export const useLazoUser = () => {
  const context = useContext(LazoUserContext);
  if (context === undefined) {
    throw new Error("useLazoUser debe ser usado dentro de un LazoUserProvider");
  }
  return context;
};
